module.exports = __webpack_public_path__ + "static/img/a_img.4fc34fc7.png";